





























































import Vue from "vue";
// util
import * as notifyUtil from "@/commons/utils/notifyUtil";

export default Vue.extend({
  name: "Login",
  data() {
    return {
      userEmailAddress: "" as string,
      userPassword: "" as string,
      showPassword: false as boolean,
      loading: false as boolean,
      baseUrl: process.env.BASE_URL as string,
      companyLink: "https://flux-g.com/",
      privacyPolicyLink: "https://flux.jp/devicepolicy/",
    };
  },
  methods: {
    doLogin() {
      this.loading = true;
      this.$store
        .dispatch("auth/login", {
          emailAddress: this.userEmailAddress,
          password: this.userPassword,
        })
        .then(() => {
          if (this.$route.query.redirect) {
            this.$router.push({ name: this.$route.query.redirect as string });
          } else {
            this.$router.push({ name: "Home" });
          }
        })
        .catch(() => {
          notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.login"));
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
});
